export default __webpack_public_path__ + "static/media/sbu-2020-s500w-galleryimages-2-201002.b0d2ea8d.jpg";